<template>
  <div>
    <v-toolbar
      color="cyan"
      dark
      tabs
    >
      <v-btn icon dark @click.native.stop="back()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->

      <v-toolbar-title>ข้อมูล {{ personData.fullname }} - {{ personData.personType.name }}</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>

      <v-tabs
        slot="extension"
        v-model="tab"
        color="cyan"
        grow
      >
        <v-tabs-slider color="yellow"></v-tabs-slider>

        <v-tab
          v-for="item in items"
          :key="item.key"
          v-if="hasAccess(item.roles)"
        >
          {{ item.label }}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item.key"
        v-if="hasAccess(item.roles)"
      >
        <v-card flat>
          <v-card-text>
            <component :is="item.key" :personId="personId"></component>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import BasicInfo from './basicInfo'
import DocumentInfo from './document'
import EducationInfo from './education'
import ExpertiseInfo from './expertise'
import PortfolioInfo from './portfolio'
import TeachingInfo from './teaching'
import WorkInfo from './work'
import AccountInfo from './account'

export default {
  props: [ 'personId' ],
  components: {
    BasicInfo,
    DocumentInfo,
    EducationInfo,
    ExpertiseInfo,
    PortfolioInfo,
    TeachingInfo,
    WorkInfo,
    AccountInfo
  },
  mixins: [ hasAccessMixin ],
  data () {
    return {
      tab: null,
      items: [
        { key: 'basic-info', label: 'ข้อมูลพื้นฐาน', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        // { key: 'leave-info', label: 'สิทธิการลา' },
        { key: 'education-info', label: 'การศึกษา', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        { key: 'work-info', label: 'การทำงาน', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        { key: 'portfolio-info', label: 'ผลงานวิจัย/ผลงานทางการศึกษา', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        { key: 'expertise-info', label: 'สาขา/เรื่องที่เชียวชาญ', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        { key: 'teaching-info', label: 'ประสบการณ์ด้านการสอน', roles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER', 'ROLE_VIEWER'] },
        // { key: 'training-info', label: 'การเข้าอบรม' },
        { key: 'document-info', label: 'เอกสาร', roles: ['ROLE_ADMIN', 'ROLE_SERVICE'] },
        { key: 'account-info', label: 'บัญชีผู้ใช้', roles: ['ROLE_ADMIN', 'ROLE_SERVICE'] }
      ]
    }
  },
  computed: {
    ...mapGetters({
      personData: 'person/personData'
    }),
  },
  created () {
    this.$store.dispatch('person/fetchPerson', this.personId)
  },
  methods: {
    back () {
      this.$router.back()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/person/shows/index.vue